/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TraceMaterial } from '../../models/trace-material';

export interface GetTraceMaterialAssigned$Params {
  workCenterId: number;
}

export function getTraceMaterialAssigned(http: HttpClient, rootUrl: string, params: GetTraceMaterialAssigned$Params, context?: HttpContext): Observable<StrictHttpResponse<TraceMaterial>> {
  const rb = new RequestBuilder(rootUrl, getTraceMaterialAssigned.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TraceMaterial>;
    })
  );
}

getTraceMaterialAssigned.PATH = '/api/v1/TraceMaterial/{workCenterId}';
